import { render, staticRenderFns } from "./SinvoiceView.vue?vue&type=template&id=61b09e97&scoped=true"
import script from "./SinvoiceView.vue?vue&type=script&lang=js"
export * from "./SinvoiceView.vue?vue&type=script&lang=js"
import style0 from "./SinvoiceView.vue?vue&type=style&index=0&id=61b09e97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b09e97",
  null
  
)

export default component.exports